export enum ScrapFinishedSelector {
  NONE = 'NONE',

  PATH = 'PATH',

  MATERIAL_ID = 'MATERIAL_ID',
}
